export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/tenant/dashboard/index.js